import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import SearchPanel from "@widgets/SearchPanel";
import { fnGetDataSet } from "@shared/api/restApi";
import { getInitFormData } from "@shared/utils/CommonUtils";
import { showDialog } from "@widgets/CommonDialog";
import SnGrid from "@shared/components/GridV2/SnGrid";
import { SnGridRef } from "@shared/components/GridV2/SnGridTypes";
import { menuInfo } from "@shared/type/CommonType";

interface Props {
  Menuprops: menuInfo;
}

// 수불체크리스트(선입선출) — 조회 전용.
// FIFO_IN(입고) + FIFO_OUT(출고)를 UNION한 sn_mtl_evl_rep_015_01 을 단일 그리드로 표시한다.
// 정렬은 쿼리(프로젝트/품목코드/일자/전표구분)로 고정 — 헤더 수동정렬은 컬럼 yn_allowsorting='N'
// 로 막는다(정렬을 바꾸면 선입선출 순서가 왜곡됨).
const SN_MTL_EVL_REP_015 = forwardRef(({ Menuprops }: Props, ref) => {
  const searchRef = useRef<any>(null);
  const gridRef = useRef<SnGridRef>(null);

  const [formData, setFormData] = useState<any>();
  const [formControlData, setFormControlData] = useState<any[]>([]);
  const [columns, setColumns] = useState<any[]>([]);
  const [dataSource, setDataSource] = useState<any[]>([]);

  useEffect(() => {
    const fetchForm = async () => {
      try {
        const rtn: any = await getInitFormData();
        setFormControlData(rtn.formControlData);
        setFormData(rtn.formData);
        setColumns(rtn.grid.grid1);
      } catch (error) {}
    };
    fetchForm();
  }, []);

  useImperativeHandle(ref, () => ({
    onSearch,
  }));

  const onSearch = async () => {
    try {
      const data: any = await fnGetDataSet({
        id: "sn_mtl_evl_rep_015_01",
        params: searchRef.current?.getFormdata?.() ?? {},
      });
      const rows = data?.[0] ?? [];
      setDataSource(rows);
      if (!rows.length) {
        await showDialog("alter", "조회된 수불내역이 없습니다.");
      }
    } catch (error) {}
  };

  return (
    <div className="h-full flex flex-col">
      <div className="mb-1">
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
        />
      </div>
      <div className="flex-1 min-h-0">
        <SnGrid
          ref={gridRef}
          columnConfig={columns}
          rowData={dataSource}
          etcProps={{
            rowSelection: "single",
            isEditable: false,
            title: "수불체크리스트(선입선출)",
          }}
        />
      </div>
    </div>
  );
});

export default SN_MTL_EVL_REP_015;
